
import axios from "axios";
import { getDocumentoID, getEdad, getGeneroID, getPrecioPlus, getPrecioConecta, getApiLogisticsURL } from "../utils/functions";
import VueCookies from 'vue-cookies';


const MiscState = require("./Misc.js")

const state = {
  ItsPromotor: false,
  CreatedByPromotor: false,
  MainMemberValidate: false,
  ZoneValidate: false,
  MembersValidate: false,

  Product: "",
  Nombre: "",
  Apellido: "",
  Email: "",
  CodigoArea: "",
  Celular: "",
  Tipo: "DNI",
  Documento: "",
  Nacimiento: "",
  Genero: "",
  Antecedentes: [],
  Direccion:
  {
    Feeble_location: false,
    Calle: "",
    Altura: "",
    Piso: "",
    MissingFloor: false,
    ViveEnDepartamento: false,
    EsLoteManzana: false,
    Localidad: undefined,
    Busqueda: undefined,
    Latitud: undefined,
    Longitud: undefined,
    Barrio: "",
    BarrioSN: false,
    CP: "",
    EntreCalles: "",
    Lote: "",
    Manzana: "",
    Torre: "",
    Departamento: "",
    Observaciones: "",
    Geolocalizado: 1,
  },
  Ciudad: "",
  Provincia: "",
  PlaceId: "",
  Ciudad: "",
  Cotizacion: false,
  Price: undefined,
  Cupon: undefined,
  Members: [],
  AcceptTerms: false,
  AntecedentesComentarios: {
    otrasEnfermedades: "",
    comentariosObraSocial: ""
  },
  PaymentMethod: "Credit",
  Cuotas: "1",
  utv: 0,
  EmergencyContacts: [
    {
      Nombre: '',
      Apellido: '',
      Parentesco: "",
      CodArea: '',
      Celular: ''
    }
  ],
  EmergencyContactValidate: false,
  EmergencyContactsValidate: false,
  Envio: {
    modo: "home",
    sucursal: null,
    domicilio: {
      cp: "",
      provincia: "",
      calle: "",
      numero: "",
      piso: "",
      torre: "",
      departamento: "",
      lote: "",
      manzana: "",
      barrio: "",
      entreCalles: "",
      ciudad: "",
      referencia: "",
      geolocalizado: 1
    },
    Offices: []
  },
  EnvioValidate: false,
  Provincia: "",
  PlaceId: "",
}

const ConectaState = {
  namespaced: true,
  state: state,
  getters: {
    getCity(state) {
      return state.Ciudad;
    },
    getTrackingPromo(state) {
      return state.TrackingPromo;
    },
    getCupon(state) {
      return state.Cupon;
    },
    getSteps(state) {
      // 6 pasos: 1..6 (se eliminó "Tu contacto de emergencia")
      if (state.CreatedByPromotor) {
        return [
          { id: "1", enable: true },
          { id: "2", enable: true },
          { id: "3", enable: true },
          { id: "4", enable: true },
          { id: "5", enable: true },
          { id: "6", enable: true },
        ];
      }

      if (!state.MainMemberValidate)
        return [
          { id: "1", enable: true },
          { id: "2", enable: false },
          { id: "3", enable: false },
          { id: "4", enable: false },
          { id: "5", enable: false },
          { id: "6", enable: false },
        ];

      if (!state.ZoneValidate)
        return [
          { id: "1", enable: true },
          { id: "2", enable: true },
          { id: "3", enable: false },
          { id: "4", enable: false },
          { id: "5", enable: false },
          { id: "6", enable: false },
        ];

      // Paso 4 (antes 5): contacto de emergencia cargado (singular)
      if (!state.EmergencyContactValidate)
        return [
          { id: "1", enable: true },
          { id: "2", enable: true },
          { id: "3", enable: true },
          { id: "4", enable: false },
          { id: "5", enable: false },
          { id: "6", enable: false },
        ];


      // Paso 5 (antes 6): integrantes + regla de edad
      if (!state.MembersValidate)
        return [
          { id: "1", enable: true },
          { id: "2", enable: true },
          { id: "3", enable: true },
          { id: "4", enable: true },
          { id: "5", enable: false },
          { id: "6", enable: false },
        ];

      // Paso 6 (antes 7): envío/confirmación final
      if (!state.EnvioValidate)
        return [
          { id: "1", enable: true },
          { id: "2", enable: true },
          { id: "3", enable: true },
          { id: "4", enable: true },
          { id: "5", enable: true },
          { id: "6", enable: false },
        ];

      return [
        { id: "1", enable: true },
        { id: "2", enable: true },
        { id: "3", enable: true },
        { id: "4", enable: true },
        { id: "5", enable: true },
        { id: "6", enable: true },
      ];
    },


    getShow: state => step => {

      if (step === 1) {
        if (state.Product == "") return true
        return false;
      }

      if (step === 2) {
        if (state.Product == "" || state.Cotizacion) return false;
        return true;
      }

      if (step === 3) {
        if (state.ItsPromotor)
          return state.Product == "" ? false : true;
        if (!state.Cotizacion) return false;
        return true;
      }


    },

    getShowForm: state => step => {
      if (step === 2) {
        if (state.MainMemberValidate === false)
          return false;

        return true;
      }

      // if(step === 3 || step === 4) {
      //   if(state.MainMemberValidate === false || state.ZoneValidate === false) {
      //     return false;
      //   }
      //   return true;
      // }

      if (step === 3) {
        if (!state.MainMemberValidate || !state.ZoneValidate) {
          return false;
        }
        return true;
      }

      if (step === 4) {
        if (state.EmergencyContactValidate === false) {
          return false;
        }
        return true;
      }

      // Paso 5: mostrar cotización si los pasos previos están OK
      if (step === 5) {
        // deben estar validados: 1) titular, 2) zona, 3) contacto de emergencia
        if (!state.MainMemberValidate || !state.ZoneValidate || !state.EmergencyContactValidate || !state.MembersValidate) {
          return false;
        }
        // la regla de edad ya bloquea el botón del paso 4 (getDisableThirdStep)
        return true;
      }


      // Paso 6: ahora valida envío/confirmación final (lo que antes hacía el paso 7)
      // Paso 6: se muestra si los pasos previos están validados
      if (step === 6) {
        if (state.CreatedByPromotor) return true;
        return state.EnvioValidate
      }

    },

    getEdadMainMember(state) {
      if (!state.Nacimiento) {
        return undefined;
      }

      var fecha = new Date();
      var fechaNacimiento = new Date(state.Nacimiento);
      var edad = fecha.getFullYear() - fechaNacimiento.getFullYear();
      var m = fecha.getMonth() - fechaNacimiento.getMonth();
      if (m < 0 || (m === 0 || fecha.getDate() < fechaNacimiento.getDate()))
        edad--;

      if (edad === -1) {
        return 0;
      }
      return edad;
    },

    getMembers(state) {
      return state.Members;
    },
    getRelojPrice(state) {
      let total = 0;

      if (state.Product == '1') {
        total += Number(state.Price?.reloj_price || 0);
      }

      if (Array.isArray(state.Members)) {
        state.Members.forEach(member => {
          if (member.Product == '1') {
            total += Number(member.Price?.reloj_price || 0);
          }
        });
      }

      return total;
    },
    getPayloadMemberValidate(state) {
      const data = {
        'firstname': state.Nombre,
        'lastname': state.Apellido,
        'email': state.Email,
        'document_type': '1',
        'document_number': String(state.Documento),
        'gender': '1',
        'birthday': state.Nacimiento,
        'phone': `${state.CodigoArea}-${state.Celular}`,
      }

      return data;
    },

    getContinue: state => step => {
      if (step === 1) {
        const { Nombre, Apellido, Email, CodigoArea, Celular, Tipo, Documento, Genero, Nacimiento } = state;

        if (state.Nacimiento) {
          var fecha = new Date();
          var fechaNacimiento = new Date(state.Nacimiento);
          var edad = fecha.getFullYear() - fechaNacimiento.getFullYear();
          var m = fecha.getMonth() - fechaNacimiento.getMonth();
          if (m < 0 || (m === 0 || fecha.getDate() < fechaNacimiento.getDate()))
            edad--;

          if (edad < -1) {
            return false;
          }
        }

        const patternEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        if (!patternEmail.test(state.Email)) {
          return false;
        }

        if (Nombre === "" || Apellido === "" || Email === "" || CodigoArea === "" || Celular === "" || Tipo === "" || Documento === "" || Genero === "" || Nacimiento === "") {
          return false;
        }

        const LengthCelularCompleto = state.CodigoArea.length + state.Celular.length;
        if (LengthCelularCompleto !== 10) {
          return false;
        }
        return true;
      }
      if (step === 2) {
        const {
          Calle,
          Altura,
          CP,
          Barrio,
          BarrioSN,
          Geolocalizado,
          MissingFloor,
          ViveEnDepartamento,
          EsLoteManzana,
          Departamento,
          Lote,
          Manzana
        } = state.Direccion;

        if (!state.Ciudad) return false;
        if (!state.Provincia) return false;
        if (!Calle) return false;
        if (!CP) return false;

        // Barrio es requerido en modo manual, excepto si el usuario marcó S/N
        if (Geolocalizado === 0 && !Barrio && !BarrioSN) return false;

        if (!MissingFloor && !Altura) return false;

        if (ViveEnDepartamento && !Departamento) return false;

        if (EsLoteManzana && (!Lote || !Manzana)) return false;

        return true;
      }
      if (step === 3) {
        return true;
      }
    },

    getPayloadValidateAddress(state) {
      const { Direccion } = state;
      const { Latitud, Longitud, Localidad, Feeble_location } = Direccion;

      return `coords[lat]=${Latitud}&coords[lng]=${Longitud}&zone=${Localidad.id}&feeble_location=${Feeble_location}`;
    },

    getPayloadMemberValidate(state) {
      const data = {
        'firstname': state.Nombre,
        'lastname': state.Apellido,
        'email': state.Email,
        'document_type': '1',
        'document_number': String(state.Documento),
        'gender': '1',
        'birthday': state.Nacimiento,
        'phone': `${state.CodigoArea}-${state.Celular}`,
      }

      return data;
    },
    getDisableThirdStep() {
      // Bloquea SOLO si el TITULAR tiene 75 o más
      // y todavía NO hay ningún integrante menor de 75.
      // Si el titular ≤ 74, no se bloquea por esta regla.
      const titularMayorOIgual75 = getEdad(state.Nacimiento) > 74;

      // ¿Existe al menos un integrante < 75?
      const hayIntegranteMenor75 = state.Members.some(m => getEdad(m.Nacimiento) < 75);

      return titularMayorOIgual75 && !hayIntegranteMenor75;
    },
    getDisableFourthStep() {
      if (state.EmergencyContacts[0].Nombre == "" || state.EmergencyContacts[0].Apellido == "" || state.EmergencyContacts[0].Parentesco == "" || state.EmergencyContacts[0].CodArea == "" || state.EmergencyContacts[0].Celular === "") {
        return true;
      }
      return false;
    },
    getDisableSixthStep() {
      if (state.Envio.modo === 'pickup' && !state.Envio.sucursal) {
        return true;
      }

      if (state.Envio.modo === 'home') {
        const { calle, ciudad, cp, numero, provincia } = state.Envio.domicilio;
        const missingFloor = state.Direccion.MissingFloor;
        const numeroOk = missingFloor || String(numero || '').trim().length > 0;
        if (!calle || !ciudad || !cp || !numeroOk || !provincia) {
          return true;
        }
      }

      return false;
    },
    getEmergencyContact(state) {
      return state.EmergencyContacts[state['EmergencyContacts'].length - 1];
    },
    getTotalPromocionFamiliar(state) {
      const CantidadFamiliares = state.Members.length + 1;

      const Promocion = MiscState.default.state.Resources.prices_group_discount.find(promocion => {
        const { from, to } = promocion;
        return CantidadFamiliares >= Number(from) && CantidadFamiliares <= Number(to);
      });

      return Promocion;
    },
    getTotal(state, getters) {
      var { CreatedByPromotor } = state;

      if (!state.Price) {
        return null;
      }

      const { price } = state.Price;

      if (!price) {
        return null;
      }

      var Total = 0;

      var cookies = document.cookie.split(";").map(cookie => cookie.trim());
      var cookiesObject = {};

      cookies.forEach(cookie => {
        var [name, value] = cookie.split("=");
        cookiesObject[name] = decodeURIComponent(value);
      });

      Total += Number(price);

      var utmSourceExists = false;

      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);

      // Verificar si existe "utm_source" y obtener su valor
      if (params.has("utm_source")) {
        const utmSource = params.get("utm_source");
        if (utmSource == "cotizacionwhatsapp") {
          CreatedByPromotor = true;
        }
      }

      if (window.location.search.includes("utm_source=") && getters.getTrackingPromo != null) {
        utmSourceExists = window.location.search.includes("utm_source=");
      }

      const ItsPromotor = state.ItsPromotor || (VueCookies.get("codPromotor") !== null);

      if (!CreatedByPromotor && !utmSourceExists && !ItsPromotor) {
        // Si es un usuario común
        let discount_payment_method = 0;
        state.PaymentMethod === "Debit"
          ? (discount_payment_method = Number(state.Price.discount_cbu))
          : (discount_payment_method = Number(state.Price.discount_cc));

        if (discount_payment_method !== 0) {
          // Si hay promo, piso el precio con la promo
          var discountAmount = Total * (discount_payment_method / 100);
          Total -= discountAmount;
        }
      } else {
        // Si es un promotor
        state.Price.discount = "0.00";
        state.Price.discount_comment = null;
      }

      Total = Math.ceil(Total);


      state.Members.forEach(member => {
        if (!CreatedByPromotor && !utmSourceExists && !ItsPromotor) {
          let discount_pm = "cc";
          state.PaymentMethod === "Debit" ? (discount_pm = "cbu") : (discount_pm = "cc");

          // NOTA: uso template string correctamente en la key
          if (member.Price[`discount_${discount_pm}`] === "0.00") {
            Total += Math.ceil(Number(member.Price.price));
          } else {
            Total +=
              Math.ceil(Number(member.Price.price)) -
              (Math.ceil(Number(member.Price.price)) * (Number(member.Price[`discount_${discount_pm}`]) / 100));
          }
        } else {
          Total += Math.ceil(Number(member.Price.price));
        }
      });



      const PromoTracking = getters.getTrackingPromo;

      if (PromoTracking) {
        const { discount, branch } = PromoTracking;

        const LocalidadId = state.Direccion.Localidad.id;

        if (branch === "0" || branch === LocalidadId)
          if (Number(discount) > 0)
            Total = Math.ceil(Total - (Total * (Number(discount) / 100)));
      }

      // UTV
      let utvUnitPrice = 0;
      if (getters.getShowUTV) {
        utvUnitPrice = MiscState.default.state.Resources.prices_stamps[3].price;

        if (state.utv == 1)
          Total = (utvUnitPrice * (state.Members.length + 1)) + Total;
      }

      // --- Reloj: sumatoria independiente (titular + cada miembro) ---
      // Cambiá 'reloj_price' si tu key es distinta (p.ej. 'watch_price')
      // let watchTotal = 0;

      // if (state.Product == '1') {
      //   watchTotal += Number(state.Price?.reloj_price || 0);   // <--- aquí
      // }

      // if (Array.isArray(state.Members)) {
      //   state.Members.forEach(m => {
      //     if (m?.Product == '1') {
      //       watchTotal += Number(m.Price?.reloj_price || 0);   // <--- y aquí
      //     }
      //   });
      // }
      // ----------------------------------------------------------------

      // Cupón: respetamos el flujo actual pero sumamos UTV (ya estaba) + reloj aparte
      if (state.Cupon) {
        let total = Number(state.Cupon.totalWithGiftcard);

        state.utv === 1 ? (total += (utvUnitPrice * (state.Members.length + 1))) : null;

        // Sumar costo de reloj al total final, independiente a cupones/promos
        //total += watchTotal;

        return Math.ceil(total);
      }

      // Sin cupón: sumamos el costo de reloj al final de todo
      //Total += watchTotal;

      return Math.ceil(Total);
    },


    getMainMember(state) {
      return state;
    },
    getShowUTV(state) {
      const { CreatedByPromotor, ItsPromotor, Direccion } = state;

      // if(CreatedByPromotor)
      //   return false;

      const { Localidad } = Direccion;

      if (Localidad.id == 2)
        return false;

      return true;
    },
    envioValido(state) {
      const { modo, sucursal, domicilio } = state.Envio;
      if (modo === 'pickup') return !!sucursal;
      if (modo === 'home') {
        const req = ['cp', 'provincia', 'calle', 'ciudad'];
        const baseOk = req.every(k => String(domicilio[k] || '').trim().length);
        const missingFloor = state.Direccion.MissingFloor;
        const numeroOk = missingFloor || String(domicilio.numero || '').trim().length > 0;
        return baseOk && numeroOk;
      }
      return false;
    },

  },
  mutations: {
    setInitState(State) {
      State = structuredClone(state);
    },
    setLocation(state, localidad) {
      state.Direccion.Localidad = localidad;
      const [latitud, longitud] = localidad.coords_center.coordinates;
      state.Direccion.Latitud = latitud;
      state.Direccion.Longitud = longitud;
    },
    setGoogleLocation(state, payload) {
      const {
        city,
        province,
        route,
        streetNumber,
        cp,
        lat,
        lng,
        place,
        address,
        neighborhood,
        nationalZone
      } = payload;

      state.Ciudad = city || "";
      state.Provincia = province || "";
      state.PlaceId = place?.place_id || "";

      state.Direccion.Calle = route || "";
      state.Direccion.Altura = streetNumber || "";

      // Si Google no devuelve CP (frecuente en búsquedas de calle sin número),
      // intentar tomar el primer código postal del nationalZone como fallback
      let resolvedCp = cp || "";
      if (!resolvedCp && nationalZone && nationalZone.postal_codes) {
        try {
          const codes = typeof nationalZone.postal_codes === "string"
            ? JSON.parse(nationalZone.postal_codes)
            : nationalZone.postal_codes;
          if (Array.isArray(codes) && codes.length > 0) {
            resolvedCp = String(codes[0]);
          }
        } catch (e) { /* ignore */ }
      }
      state.Direccion.CP = resolvedCp;
      state.Direccion.Latitud = lat;
      state.Direccion.Longitud = lng;
      state.Direccion.Barrio = neighborhood || "";
      state.Direccion.Feeble_location = false;
      state.Direccion.Busqueda = place
        ? {
          address: address || place.address,
          place_id: place.place_id
        }
        : undefined;

      if (nationalZone) {
        state.Direccion.Localidad = {
          ...nationalZone,
          title: city || nationalZone.title,
          province: province || nationalZone.province,
          postal_codes: resolvedCp ? JSON.stringify([resolvedCp]) : nationalZone.postal_codes
        };
      }

      state.Envio.modo = "home";

      state.Envio.domicilio = {
        ...state.Envio.domicilio,
        cp: resolvedCp || state.Envio.domicilio.cp || "",
        provincia: province || state.Envio.domicilio.provincia || "",
        calle: route || state.Envio.domicilio.calle || "",
        numero: streetNumber || state.Envio.domicilio.numero || "",
        piso: state.Direccion.Piso || state.Envio.domicilio.piso || "",
        torre: state.Direccion.Torre || state.Envio.domicilio.torre || "",
        departamento: state.Direccion.Departamento || state.Envio.domicilio.departamento || "",
        lote: state.Direccion.Lote || state.Envio.domicilio.lote || "",
        manzana: state.Direccion.Manzana || state.Envio.domicilio.manzana || "",
        barrio: neighborhood || state.Direccion.Barrio || state.Envio.domicilio.barrio || "",
        entreCalles: state.Direccion.EntreCalles || state.Envio.domicilio.entreCalles || "",
        ciudad: city || state.Envio.domicilio.ciudad || "",
        referencia: state.Direccion.Observaciones || state.Envio.domicilio.referencia || ""
      };
    },
    setProduct(state, product) {
      state.Product = product;
    },
    setCupon(state, cupon) {
      state.Cupon = cupon;
    },
    setCotizacion(state, cotizacion) {
      state.Cotizacion = cotizacion;
    },
    setCreatedByPromotor(state, created) {
      state.CreatedByPromotor = created;
      if (created) {
        state.MainMemberValidate = true;
        state.ZoneValidate = true;
        state.EmergencyContactValidate = true;
        state.MembersValidate = true;
      }
    },
    updateValuePerson(state, { key, value }) {

      state[key] = value;
    },
    // Conecta.js (mutations)
    AddAntecedentes(state, Antecedente) {
      const getId = x => Number(x && typeof x === 'object' ? x.id : x);
      const id = getId(Antecedente);

      // 999 es "Ninguno": pisa todo
      if (id === 999) {
        state.Antecedentes = [999];
        return;
      }

      // Si agrego algo distinto de 999, saco 999 si estaba
      state.Antecedentes = state.Antecedentes
        .map(a => getId(a))
        .filter(a => a !== 999);

      if (!state.Antecedentes.some(a => a === id)) {
        state.Antecedentes.push(id);
      }
    },

    RemoveAntecedentes(state, Antecedente) {
      const getId = x => Number(x && typeof x === 'object' ? x.id : x);
      const id = getId(Antecedente);
      const idx = state.Antecedentes
        .map(a => getId(a))
        .findIndex(a => a === id);
      if (idx > -1) state.Antecedentes.splice(idx, 1);
    },

    UpdateAntecedente(state, Antecedente) {
      state.AntecedentesComentarios[Antecedente.key] = Antecedente.value;
    },
    setMainMemberValid(state) {
      state.MainMemberValidate = true;
    },
    checkPrices(state) {
      const isAlone = state.Members.length === 0;
      const Edad = getEdad(state.Nacimiento);

      const Precio = getPrecioConecta(state.Product, Edad);

      const utmSourceExists = window.location.search.includes("utm_source=") && state.TrackingPromo != null;
      const isPromotor = (VueCookies.get('codPromotor') !== null && VueCookies.get('promotorName') !== null) || state.ItsPromotor;

      state.Price = Precio;

      if (isPromotor || utmSourceExists) {
        state.Price.discount = "0.00";
        state.Price.discount_comment = "";
        state.Price.price_extra_comments = "";
        //state.ItsPromotor = true;
        if (utmSourceExists) {
          state.ItsPromotor = false;
        }
      }

      for (const Member of state.Members) {
        const EdadMember = getEdad(Member.Nacimiento);
        var PrecioMember = !Member.Product ? getPrecioPlus(EdadMember) : getPrecioConecta(Member.Product, EdadMember);

        if (isPromotor || utmSourceExists) {
          PrecioMember.discount = "0.00";
          PrecioMember.discount_comment = "";
          PrecioMember.price_extra_comments
        }

        Member.Price = PrecioMember;
      }
    },

    setUtv(state) {
      state.utv = state.utv === 1 ? 0 : 1;
    },
    setValidateMembers(state) {
      console.log("setValidateMembers");
      state.MembersValidate = true;
    },
    AddMember(state, Member) {
      state.Members.push(Member);
    },
    AddEmergencyContact(state, Contact) {
      state.EmergencyContacts.push(Contact);
    },
    updateMember(state, payload) {
      const { Index, Member } = payload;

      state.Members[Index].Nombre = Member.Nombre;
      state.Members[Index].Apellido = Member.Apellido;
      state.Members[Index].Email = Member.Email;
      state.Members[Index].Celular = Member.Celular;
      state.Members[Index].Tipo = Member.Tipo;
      state.Members[Index].Documento = Member.Documento;
      state.Members[Index].Nacimiento = Member.Nacimiento;
      state.Members[Index].Localidad = Member.Localidad;
      state.Members[Index].Direccion = Member.Direccion;
      state.Members[Index].Price = Member.Price;
      state.Members[Index].Antecedentes = Member.Antecedentes;
      state.Members[Index].AntecedentesComentarios = Member.AntecedentesComentarios;
      state.Members[Index].EmergencyContacts = Member.EmergencyContacts;
      state.Members[Index].Product = Member.Product;
    },
    RemoveMember(state, ID) {
      state.Members = state.Members.filter(member => member.ID !== ID);
    },
    RemoveEmergencyContact(state, ID) {
      state.EmergencyContacts = state.EmergencyContacts.filter(contact => contact.ID !== ID);
    },
    setValidateEmergencyContacts(state) {
      state.EmergencyContactsValidate = true;
    },
    setValidateEmergencyContact(state) {
      state.EmergencyContactValidate = true;
    },
    AddEmergencyContact(state, Contact) {
      state.EmergencyContacts.push(Contact);
    },
    // updateEmergencyContact(state, Contact) {
    //   state.EmergencyContacts[0] = Contact;
    // },
    updateEmergencyContact(state, payload) {

      const { Nombre, Apellido, Parentesco, CodArea, Celular } = payload;

      let Index = 0;
      payload.Index ? Index = payload.Index : null;

      state.EmergencyContacts[Index].Nombre = Nombre;
      state.EmergencyContacts[Index].Apellido = Apellido;
      state.EmergencyContacts[Index].Parentesco = Parentesco;
      state.EmergencyContacts[Index].Celular = Celular;
      state.EmergencyContacts[Index].CodArea = CodArea;
    },

    updateMemberEmergencyContact(state, payload) {


      const { memberId, Index, Nombre, Apellido, Parentesco, CodArea, Celular } = payload;

      const member = state.Members.find(m => m.ID === memberId);

      member.EmergencyContacts[Index].Nombre = Nombre;
      member.EmergencyContacts[Index].Apellido = Apellido;
      member.EmergencyContacts[Index].Parentesco = Parentesco;
      member.EmergencyContacts[Index].Celular = Celular;
      member.EmergencyContacts[Index].CodArea = CodArea;
    },
    removeMemberEmergencyContact(state, { memberId, contactIndex }) {

      const member = state.Members.find(m => m.ID === memberId);
      if (member && Array.isArray(member.EmergencyContacts)) {
        member.EmergencyContacts.splice(contactIndex, 1);
      }
    },
    setModoEnvio(state, modo) {
      state.Envio.modo = modo;
      if (modo === "home")
        state.EnvioValidate = false;
    },
    SET_ENVIO_SUCURSAL(state, suc) {
      state.Envio.sucursal = suc;
    },
    setDomicilio(state, dom) {
      state.Envio.domicilio = { ...state.Envio.domicilio, ...dom };
    },
    SET_ENVIO_FROM_PAYLOAD(state, payload) {
      if (!payload) return;
      state.Envio.modo = payload.modo;
      state.Envio.sucursal = payload.modo === 'pickup' ? payload.sucursal : null;
      state.Envio.domicilio = payload.modo === 'home' ? { ...state.Envio.domicilio, ...payload.domicilio } : state.Envio.domicilio;
    },
    setValidateShipping(state, result) {
      state.EnvioValidate = result;
    },
    setPromotor(state) {
      console.log("setPromotor mutation");
      state.ItsPromotor = true;
    },
    updateDireccionField(state, { key, value }) {
      state.Direccion[key] = value;
    },

    setGoogleLocation(state, payload) {
      const {
        city,
        province,
        route,
        streetNumber,
        cp,
        lat,
        lng,
        place,
        address,
        neighborhood,
        nationalZone
      } = payload;

      state.Ciudad = city || "";
      state.Provincia = province || "";
      state.PlaceId = place?.place_id || state.PlaceId || "";

      state.Direccion.Calle = route || "";
      state.Direccion.Altura = streetNumber || "";
      state.Direccion.CP = cp || "";
      state.Direccion.Latitud = lat;
      state.Direccion.Longitud = lng;
      state.Direccion.Barrio = neighborhood || "";
      state.Direccion.Feeble_location = false;
      state.Direccion.Busqueda = place
        ? {
          address: address || place.address,
          place_id: place.place_id
        }
        : state.Direccion.Busqueda;

      const compatibilityZone = nationalZone || state.Direccion.Localidad;

      if (compatibilityZone) {
        state.Direccion.Localidad = {
          ...compatibilityZone,
          title: city || compatibilityZone.title,
          province: province || compatibilityZone.province,
          postal_codes: cp ? JSON.stringify([cp]) : compatibilityZone.postal_codes
        };
      }

      state.Envio.domicilio = {
        ...state.Envio.domicilio,
        cp: cp || state.Envio.domicilio.cp || "",
        provincia: province || state.Envio.domicilio.provincia || "",
        calle: route || state.Envio.domicilio.calle || "",
        numero: streetNumber || state.Envio.domicilio.numero || "",
        piso: state.Direccion.Piso || state.Envio.domicilio.piso || "",
        torre: state.Direccion.Torre || state.Envio.domicilio.torre || "",
        departamento: state.Direccion.Departamento || state.Envio.domicilio.departamento || "",
        lote: state.Direccion.Lote || state.Envio.domicilio.lote || "",
        manzana: state.Direccion.Manzana || state.Envio.domicilio.manzana || "",
        barrio: neighborhood || state.Direccion.Barrio || state.Envio.domicilio.barrio || "",
        entreCalles: state.Direccion.EntreCalles || state.Envio.domicilio.entreCalles || "",
        ciudad: city || state.Envio.domicilio.ciudad || "",
        referencia: state.Direccion.Observaciones || state.Envio.domicilio.referencia || ""
      };
    },
    setShippingGoogleLocation(state, payload) {
      const { city, province, route, streetNumber, cp, lat, lng, neighborhood } = payload;
      state.Envio.domicilio = {
        ...state.Envio.domicilio,
        cp: cp || state.Envio.domicilio.cp || "",
        provincia: province || state.Envio.domicilio.provincia || "",
        calle: route || "",
        numero: streetNumber || "",
        barrio: neighborhood || "",
        ciudad: city || state.Envio.domicilio.ciudad || "",
      };
    },
  },
  actions: {
    async setValidateZone({ state }) {
      state.ZoneValidate = true;

      const rawPostalCodes = state.Direccion.Localidad?.postal_codes;
      let zonePostalCodes = [];

      if (Array.isArray(rawPostalCodes)) {
        zonePostalCodes = rawPostalCodes;
      } else if (typeof rawPostalCodes === "string" && rawPostalCodes.length > 0) {
        try {
          zonePostalCodes = JSON.parse(rawPostalCodes);
        } catch (e) {
          zonePostalCodes = [];
        }
      }

      const firstPostalCode = String(state.Direccion.CP || zonePostalCodes[0] || "").trim();

      try {
        state.Envio.modo = "home";
        state.Envio.domicilio.calle = state.Direccion.Calle;
        state.Envio.domicilio.numero = state.Direccion.Altura;
        state.Envio.domicilio.piso = state.Direccion.Piso;
        state.Envio.domicilio.torre = state.Direccion.Torre || "";
        state.Envio.domicilio.departamento = state.Direccion.Departamento || "";
        state.Envio.domicilio.lote = state.Direccion.Lote || "";
        state.Envio.domicilio.manzana = state.Direccion.Manzana || "";
        state.Envio.domicilio.barrio = state.Direccion.Barrio || "";
        state.Envio.domicilio.entreCalles = state.Direccion.EntreCalles || "";
        state.Envio.domicilio.cp = firstPostalCode;
        state.Envio.domicilio.ciudad = state.Ciudad || state.Direccion.Localidad?.title || "";
        state.Envio.domicilio.provincia = state.Provincia || state.Direccion.Localidad?.province || "";
        state.Envio.domicilio.referencia = state.Direccion.Observaciones || "";

        // si seguís necesitando consultar Andreani por CP
        const LogisticsURL = getApiLogisticsURL();

        if (firstPostalCode) {
          const { data } = await axios.get(
            LogisticsURL + "/andreani/offices/?postal_code=" + firstPostalCode,
            { timeout: 20000 }
          );

          const items = data.offices || [];
          state.Envio.Offices = items;
          state.Envio.sucursal = items.length ? items[0] : null;
        } else {
          state.Envio.Offices = [];
          state.Envio.sucursal = null;
        }
      } catch (error) {
      }
    },
  }
}

export default ConectaState;